





















































































import { Component, Prop, Vue } from "vue-property-decorator";
import BarSearchPasien from "@/components/BarSearchPasien.vue";
import { userModule } from "@/store/modules/user";
import ModalKonfirmasi from "@/components/modal/KonfirmasiLogout.vue";
import { appModule } from "@/store/modules/app";

type MenuItem = {
  icon: string;
  title: string;
  vertical?: string;
  link: string;
  onclick: () => void;
};

@Component({
  components: {
    BarSearchPasien,
    ModalKonfirmasi
  }
})
export default class TheAppBar extends Vue {
  @Prop() expandDrawer: boolean;

  showDrawer = false;

  public title = "RME RSUDPS";

  titleSkriningPengunjung = "Skrining Pengunjung Rawat Inap";

  public menus: MenuItem[] = [
    {
      icon: "mdi-account",
      title: "Profile",
      link: "user-profile",
      onclick: () => {
        return this.$router.push({
          name: "user-profile"
        });
      }
    },
    {
      icon: "mdi-logout",
      title: "Logout",
      link: "login",
      onclick: () => {
        return this.handleUserActions();
      }
    }
  ];

  modalOpenKonfirmasi = false;

  msgConfirm = "";

  get user() {
    return userModule.user;
  }

  get modeSkriningPengunjung(): boolean {
    return userModule.isModeSkriningPengunjung;
  }

  handleUserActions() {
    this.modalOpenKonfirmasi = true;
    this.msgConfirm = "Anda yakin ingin keluar aplikasi?";
  }

  logout() {
    userModule.logout();

    this.$router.push("login");
  }

  openPanduanDrawer() {
    appModule.setPanduanDrawer(true);
  }
}
